// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__xgd-X","close":"styles_close__GPRkf","scrollToTop":"styles_scrollToTop__FFA-y"};